import { Link } from "react-router-dom";
import "./post.css";

export default function Post({ post }) {
  const PF = "https://backend.hoanglecf.com/images/";
  // const PF = "http://localhost:5000/images/";

  return (
    <div className="game-account-card">
      <div className="card-image-container">
        {post.photo ? (
          <img className="game-character-img" src={PF + post.photo} alt="" />
        ) : (
          <div className="character-placeholder">
            <i className="fas fa-gamepad"></i>
          </div>
        )}
        
        <div className="game-ui-overlay">
          <div className="account-id">MS: {post.title}</div>
        </div>
        {post.rentalStatus === "rented" && (
          <div className="rented-flag">Đang cho thuê</div>
        )}
      </div>
      
      <div className="card-info">
        <div className="account-info">
          <div className="account-name">
            {post?.desc?.length > 20 ? post.title : `MS - Tên acc: ${post.title}`}
          </div>
          <div className="account-specialty">
            {post?.desc?.length > 20 ? `${post.desc.substring(0, 20)}...` : `Acc chuyên: ${post.desc}`}
          </div>
          {post?.desc?.length <= 20 && (
            <div className="rental-price">
              Giá thuê: {post.price}
            </div>
          )}
        </div>
      </div>
      
      <Link to={`/post/${post._id}`} className="card-link"></Link>
    </div>
  );
}
